module.exports = __webpack_public_path__ + "static/media/SVG_menu_mypage.71c063ed.svg";